import {FC, useEffect, useState} from 'react'
import Select from 'react-select'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {Button} from '../../../../components/UI/Button'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {CampModel} from '../../features/modules/models'
import {getCampsService} from '../../features/modules/services'
import {TableOccupancyManager} from '../../features/ocupability/components/TableOccupancyManager'
import {ViewOccupancyLayout} from '../../features/ocupability/components/ViewOccupancyLayout'
import {useClients} from '../../hooks/useClients'
import {useCompanies} from '../../hooks/useCompanies'
import {useModules} from '../../hooks/useModules'
import {useOccupancy} from '../../hooks/useOccupancy'
import {useSite} from '../../hooks/useSite'

export const OccupancyPageWrapper: FC = () => {
  const {companyData} = useCompanies()
  const {clientData, getClientList, setClientData} = useClients()
  const {siteData, getSiteList, setSiteData} = useSite()
  const {layoutData, getLayoutList, setLayoutData, TipoData, setTipoData, isLoading} =
    useOccupancy()

  const [selectedOption, setSelectedOption] = useState<Record<string, string>>({})
  const [selectedOptionName, setSelectedOptionName] = useState<Record<string, string>>({})

  const [, setCamps] = useState<CampModel[] | any>([])
  const [modules, setModules] = useState<CampModel[] | any>([])
  const [, setTabCurrent] = useState(1)

  const {getModules} = useModules()

  const handleSelectChange = (e: Record<string, string>, name: string) => {
    const {value} = e
    setSelectedOption((prevState) => ({...prevState, [name]: value}))
    const {label} = e
    setSelectedOptionName((prevState) => ({...prevState, [name]: label}))
  }

  const handleClear = () => {
    setTabCurrent(1)
    setSelectedOption({
      ...selectedOption,
      company: '',
      client: '',
      site: '',
      camp: '',
      mod: '',
      hbt: '',
    })
    setSelectedOptionName({
      ...selectedOption,
      company: '',
      client: '',
      site: '',
      camp: '',
      mod: '',
      hbt: '',
    })
    setLayoutData([])
  }

  useEffect(() => {
    if (companyData && companyData.length > 0 && companyData.length === 1) {
      setSelectedOption((prevState) => ({...prevState, company: companyData[0].value}))
    }
  }, [companyData])

  useEffect(() => {
    if (clientData && clientData.length > 0 && clientData.length === 1) {
      setSelectedOption((prevState) => ({...prevState, client: clientData[0].value}))
    }
  }, [clientData])

  useEffect(() => {
    if (siteData && siteData.length > 0 && siteData.length === 1) {
      setSelectedOption((prevState) => ({...prevState, site: siteData[0].value}))
    }
  }, [siteData])

  useEffect(() => {
    setTipoData('')
    setClientData([])
    setSiteData([])
    setModules([])
    setCamps([])
    if (selectedOption['company']) {
      setSelectedOption({
        ...selectedOption,
        client: '',
        site: '',
        camp: '',
        mod: '',
        pis: '',
        hbt: '',
      })
      getClientList(selectedOption['company'])
    }
    console.log('selectedOption >', selectedOption)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption.company])

  useEffect(() => {
    setTipoData('')
    setSiteData([])
    setModules([])
    setCamps([])
    if (selectedOption['client']) {
      setSelectedOption({...selectedOption, site: '', camp: '', mod: '', hbt: ''})
      getSiteList(selectedOption['client'])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption.client])

  useEffect(() => {
    setCamps([])
    setLayoutData([])
    setModules([])
    if (selectedOption['site'] && selectedOption['site'] !== '0') {
      loadCampsLayout()
      getCamps()
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption.site])

  useEffect(() => {
    if (selectedOption['camp'] && selectedOption['camp'] !== '0') {
      //loadModulesLayout(selectedOption.camp);
      getModulesFn(selectedOption.camp)
    } else {
      if (selectedOption['site']) {
        setModules([])
        loadCampsLayout()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption.camp])

  useEffect(() => {
    if (selectedOption['mod'] && selectedOption['mod'] !== '0') {
      loadFloorsLayout(selectedOption.mod, selectedOptionName.mod)
    } else {
      if (selectedOption['camp']) {
        loadModulesLayout(selectedOption.camp, selectedOptionName.camp)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption.mod])

  const getCamps = async () => {
    try {
      setModules([])
      setSelectedOption({...selectedOption, camp: '', mod: '', hbt: ''})
      setSelectedOptionName({...selectedOptionName, camp: '', mod: '', hbt: ''})
      let obj: CampModel = {
        id: '',
        nombre: '',
        siteId: selectedOption.site,
        clienteId: '',
        companiaId: '',
        site: '',
        nombreCliente: '',
        nombreCompania: '',
      }
      const response = await getCampsService(obj, 1)
      const data = response.data.data
      const mappedCamps = data?.map((camp) => ({value: camp.id, label: camp.nombre}))

      setCamps([{value: '0', label: 'TODOS'}, ...mappedCamps])
    } catch (error) {
      setCamps([])
    }
  }

  const getModulesFn = async (campamentoId: string) => {
    const data = await getModules({CampamentoId: campamentoId})
    setModules([{value: '0', label: 'TODOS'}, ...data])
  }

  const loadCampsLayout = () => {
    setSelectedOption({...selectedOption, camp: '', mod: '', hbt: ''})
    setSelectedOptionName({...selectedOptionName, camp: '', mod: '', hbt: ''})
    let TipoDataIn = 'CAP'
    setTipoData(TipoDataIn)
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
    })
  }

  const loadModulesLayout = (campamentoId: any, name: any) => {
    let TipoDataIn = 'MOD'
    setTipoData(TipoDataIn)
    setLayoutData([])
    setModules([])
    setSelectedOption({...selectedOption, camp: campamentoId, mod: '', hbt: ''})
    setSelectedOptionName({...selectedOptionName, camp: name, mod: '', hbt: ''})
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: campamentoId || 'zVw7@qUywJA=',
      //CampamentoId:campa.site,
    })
  }

  const loadFloorsLayout = (moduloId: any, name: string) => {
    let TipoDataIn = 'PIS'
    setTipoData(TipoDataIn)
    setLayoutData([])
    setSelectedOption({...selectedOption, mod: moduloId, pis: '', hbt: ''})
    setSelectedOptionName({...selectedOptionName, mod: name, pis: '', hbt: ''})
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: selectedOption.camp,
      ModuloId: moduloId,
    })
  }

  const loadHabiationsLayout = (pisoId: any, name: string) => {
    let TipoDataIn = 'HAB'
    setTipoData(TipoDataIn)
    setLayoutData([])
    setSelectedOption({...selectedOption, pis: pisoId, hbt: ''})
    setSelectedOptionName({...selectedOptionName, pis: name, hbt: ''})
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: selectedOption.camp,
      ModuloId: selectedOption.mod,
      PisoId: pisoId,
    })
  }
  const loadBedsLayout = (habitacionId: any, name: string) => {
    let TipoDataIn = 'CAM'
    setTipoData(TipoDataIn)
    setLayoutData([])
    setSelectedOption({...selectedOption, hbt: habitacionId})
    setSelectedOptionName({...selectedOptionName, hbt: name})
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: selectedOption.camp,
      ModuloId: selectedOption.mod,
      PisoId: selectedOption.pis,
      HabitacionId: habitacionId,
    })
  }

  useEffect(() => {
    setSelectedOptionName({
      ...selectedOptionName,
      client: '',
      site: '',
      camp: '',
      mod: '',
      pis: '',
      hbt: '',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptionName.company])

  useEffect(() => {
    setSelectedOptionName({...selectedOptionName, site: '', camp: '', mod: '', pis: '', hbt: ''})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptionName.client])

  useEffect(() => {
    setSelectedOptionName({...selectedOptionName, camp: '', mod: '', pis: '', hbt: ''})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptionName.site])

  useEffect(() => {
    setSelectedOptionName({...selectedOptionName, mod: '', pis: '', hbt: ''})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptionName.camp])

  useEffect(() => {
    setSelectedOptionName({...selectedOptionName, pis: '', hbt: ''})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptionName.mod])

  useEffect(() => {
    setSelectedOptionName({...selectedOptionName, hbt: ''})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptionName.pis])

  return (
    <ContainerWrapper>
      <div className='card m-5 shadow-sm'>
        <div className='card-header'>
          <div className='card-toolbar gap-4'>
            <div className='py-4'>
              <label className='form-label fw-bold'>Compañía</label>
              <Select
                isDisabled={companyData.length === 0}
                key={'company'}
                className='react-select-container w-150px mw-150px'
                classNamePrefix='react-select'
                placeholder='Selecciona una opción'
                options={companyData}
                noOptionsMessage={() => 'No hay resultados'}
                value={
                  selectedOption['company'] &&
                  companyData?.find((c: {value: string}) => c.value === selectedOption['company'])
                }
                onChange={(e) => handleSelectChange(e, 'company')}
                isSearchable={true}
              />
            </div>
            <div className='py-4'>
              <label className='form-label fw-bold'>Cliente</label>
              <Select
                isDisabled={clientData.length === 0}
                key={'client'}
                className='react-select-container w-150px mw-150px'
                classNamePrefix='react-select'
                placeholder='Selecciona una opción'
                options={clientData}
                noOptionsMessage={() => 'No hay resultados'}
                value={
                  selectedOption['client'] &&
                  clientData?.find((c: {value: string}) => c.value === selectedOption['client'])
                }
                onChange={(e) => handleSelectChange(e, 'client')}
                isSearchable={true}
              />
            </div>
            <div className='py-4'>
              <label className='form-label fw-bold'>Site</label>
              <Select
                isDisabled={siteData.length === 0}
                key={'site'}
                className='react-select-container w-150px mw-150px'
                classNamePrefix='react-select'
                placeholder='Selecciona una opción'
                options={siteData}
                noOptionsMessage={() => 'No hay resultados'}
                value={
                  selectedOption['site'] &&
                  siteData?.find((c: {value: string}) => c.value === selectedOption['site'])
                }
                onChange={(e) => handleSelectChange(e, 'site')}
                isSearchable={true}
              />
            </div>
            <div className={'py-4'}>
              <label className='form-label fw-bold'> </label>
              <Button classNameProp={'py-5'} label='Limpiar' onClick={handleClear} />
            </div>
          </div>
        </div>
        <div className='card-body py-5 '>
          {selectedOption.site && (
            <Tabs className={'sdx_sub_react_tab_panel '}>
              <TabList className={'sdx_sub_tab_panel p-0'}>
                <Tab className={'sdx_sub_tab_panel_option'} onClick={() => setTabCurrent(1)}>
                  Layout
                </Tab>
                <Tab className={'sdx_sub_tab_panel_option'} onClick={() => setTabCurrent(2)}>
                  Ejecutivo
                </Tab>
              </TabList>
              <TabPanel>
                <ViewOccupancyLayout
                  data={layoutData}
                  loadCampsLayout={loadCampsLayout}
                  selectedOptionName={selectedOptionName}
                  selectedOption={selectedOption}
                  tipoData={TipoData}
                  loadModulesLayout={loadModulesLayout}
                  loadFloorsLayout={loadFloorsLayout}
                  loadHabiationsLayout={loadHabiationsLayout}
                  loadBedsLayout={loadBedsLayout}
                  isLoadingLayout={isLoading}
                  modules={modules}
                />
              </TabPanel>
              <TabPanel>
                <TableOccupancyManager selectedOption={selectedOption} />
              </TabPanel>
            </Tabs>
          )}
        </div>
        {/* <div className='card-footer'>Footer</div> */}
      </div>
    </ContainerWrapper>
  )
}
